import { useEffect, useState } from "react";
import {
  BUZON_EQUIPO_CHANGED_EVENT,
  getBuzonEquipoEnabled,
} from "./buzonEquipo.storage";

export function useBuzonEquipoEnabled(): boolean {
  const [enabled, setEnabled] = useState(getBuzonEquipoEnabled);
  useEffect(() => {
    const on = () => setEnabled(getBuzonEquipoEnabled());
    window.addEventListener(BUZON_EQUIPO_CHANGED_EVENT, on);
    return () => window.removeEventListener(BUZON_EQUIPO_CHANGED_EVENT, on);
  }, []);
  return enabled;
}
